
import { defineComponent, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

export default defineComponent({
    name: 'NotFound',
    setup() {
        const store = useStore();
        const i18n = useI18n({ useScope: 'global' });
        const serverLocale = computed(() => store.getters['ui/languageCode']);
        i18n.locale.value = serverLocale.value;
        watch(serverLocale, () => {
            i18n.locale.value = serverLocale.value;
        });

        return {
            serverLocale,
        };
    },
});
